import { render } from "./RequestDenied.vue?vue&type=template&id=31ae5382&scoped=true"
import script from "./RequestDenied.vue?vue&type=script&lang=js"
export * from "./RequestDenied.vue?vue&type=script&lang=js"

import "./RequestDenied.vue?vue&type=style&index=0&id=31ae5382&lang=scss&scoped=true"

import exportComponent from "/data/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-31ae5382"]])

export default __exports__